<template>
    <div>
        <ot-overlap-display-modal
            ref="otOverlapDisplayModal"
            :otRequestOverlap="otRequestOverlap"
        />
        <div class="header pt-5">
            <div>
                {{ $vuetify.lang.t('$vuetify.overtimeRequestForm.overtimeRequest') }}
            </div>
            <div v-if="canSave">
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-2"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.overtimeRequestForm.cancel') }}
                </v-btn>

                <v-btn
                    @click="submit()"
                    width="150"
                    color="primary"
                    :disabled="status==''">
                    {{ $vuetify.lang.t('$vuetify.overtimeRequestForm.save') }}
                </v-btn>
            </div>
            <div v-else>
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-2"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.overtimeRequestForm.close') }}
                </v-btn>
            </div>
        </div>

        <v-form
            lazy-validation
            ref="form">
            <v-container>
                <v-row>
                    <v-col
                        cols="7"
                        class="pl-0">
                        <v-card class="content-container">
                            <v-container>
                                <v-row class="ml-2">
                                    <v-col
                                        cols="3">
                                        <span class="headline">
                                            {{ $vuetify.lang.t('$vuetify.overtimeRequestForm.profile') }}
                                        </span>
                                    </v-col>
                                    <v-col
                                        cols="9">
                                    </v-col>
                                </v-row>
                                <v-row class="ml-2">
                                    <v-col
                                        cols="3">
                                        <div class="ml-2">
                                            <div class="profile-company-image">
                                                <profile
                                                    :img="faceImg"/>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="9">
                                        <v-container>
                                            <v-row>
                                                <v-col
                                                    cols="6">
                                                    <div class="otr-label otr-name locale-font">{{$vuetify.lang.t('$vuetify.overtimeRequestForm.name')}}</div>
                                                    <div class="otr-text">{{ name }}</div>
                                                </v-col>
                                                <v-col
                                                    cols="6">
                                                    <div class="otr-label otr-employee-no">{{$vuetify.lang.t('$vuetify.overtimeRequestForm.employeeNo')}}</div>
                                                    <div class="otr-text">{{ employeeNo }}</div>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col
                                                    cols="6">
                                                    <div class="otr-label otr-name locale-font">{{$vuetify.lang.t('$vuetify.overtimeRequestForm.department')}}</div>
                                                    <div class="otr-text">{{ department }}</div>
                                                </v-col>
                                                <v-col
                                                    cols="6">
                                                    <div class="otr-label otr-employee-no">{{$vuetify.lang.t('$vuetify.overtimeRequestForm.group')}}</div>
                                                    <div class="otr-text">{{ group }}</div>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <br>
                        <v-card class="content-container">
                            <v-container>
                                <v-row class="ml-2">
                                    <v-col
                                        cols="3">
                                        <span class="headline">
                                            {{ $vuetify.lang.t('$vuetify.overtimeRequestForm.contact') }}
                                        </span>
                                    </v-col>
                                    <v-col
                                        cols="9">
                                    </v-col>
                                </v-row>
                                <v-row class="ml-2">
                                    <v-col
                                        cols="6">
                                        <div class="otr-icon float-left">
                                            <i
                                                class="icon fas fa-envelope">
                                            </i>
                                        </div>
                                        <div class="otr-label otr-name locale-font">{{$vuetify.lang.t('$vuetify.overtimeRequestForm.email')}}</div>
                                        <div class="otr-text">{{ email }}</div>
                                    </v-col>
                                    <v-col
                                        cols="6">
                                        <div class="otr-icon float-left">
                                            <i
                                                class="icon fas fa-phone-alt">
                                            </i>
                                        </div>
                                        <div class="otr-label otr-employee-no">{{$vuetify.lang.t('$vuetify.overtimeRequestForm.phoneNumber')}}</div>
                                        <div class="otr-text">{{ phoneNo }}</div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-col>
                    <v-col
                        cols="5"
                        class="pr-0">
                        <v-card class="content-container contact-card">
                            <v-container>
                                <v-row class="ml-2">
                                    <v-col
                                        cols="5">
                                        <span class="headline">
                                            {{ $vuetify.lang.t('$vuetify.overtimeRequestForm.requestStatus') }}
                                        </span>
                                    </v-col>
                                    <v-col
                                        cols="7">
                                        <toggle-overtime-request
                                            class="float-right"
                                            ref="overtimeRequest"
                                            v-model="status"
                                            :disabled="!canSave"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row class="ml-2">
                                    <v-col
                                        cols="12" class="requestStatusText">
                                        <span>{{ requestStatus }}</span>
                                    </v-col>
                                </v-row>
                                <v-row class="ml-2 mr-2 headerOfTable">
                                    <v-col cols="7">{{ $vuetify.lang.t('$vuetify.overtimeRequestForm.dateOfOvertimeWork') }}</v-col>
                                    <v-col cols="5">{{ $vuetify.lang.t('$vuetify.overtimeRequestForm.timeOfOvertimeWork') }}</v-col>
                                </v-row>
                                <div
                                    class="ml-5 mr-5"
                                    v-for="(item, index) in otRequestData"
                                    :key="`${index}`">
                                    <v-row class="rowOfOTRequest">
                                        <v-col cols="7">{{ item.periodDate }}</v-col>
                                        <v-col cols="5">{{ item.periodTime }}</v-col>
                                        <v-col cols="12" class="otr-reason pt-0">
                                            <div class="otr-label">{{$vuetify.lang.t('$vuetify.overtimeRequestForm.reason')}}</div>
                                            <div class="otr-textarea">{{ item.description }}</div>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div class="ml-5 pt-4 request-status-detail">
                                    <div class="otr-approval">
                                        <div class="otr-label">{{$vuetify.lang.t('$vuetify.overtimeRequestForm.headDepartmentApproval')}}</div>
                                        <div class="otr-text-status">{{ headDepartmentApprovalStatus }}</div>
                                        <div class="otr-text-approval">{{ headDepartmentApproval }}</div>
                                    </div>
                                    <div class="otr-approval">
                                        <div class="otr-label">{{$vuetify.lang.t('$vuetify.overtimeRequestForm.adminApproval')}}</div>
                                        <div class="otr-text-status">{{ adminApprovalStatus }}</div>
                                        <div class="otr-text-approval">{{ adminApproval }}</div>
                                    </div>
                                </div>
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>

    </div>
</template>

<script>
import Profile from '@/components/Profile'
import imgPath from '@/assets/user_default.png'
import ToggleOvertimeRequest from '@/components/InquiryAndAttendance/ToggleOvertimeRequest.vue'
import otOverlapDisplayModal from '@/components/modal/otOverlapDisplayModal.vue'
export default {
    name: 'OvertimeRequestForm',

    components: {
        Profile,
        ToggleOvertimeRequest,
        otOverlapDisplayModal
    },

    data () {
        return {
            id: null,
            status: '',
            requestStatus: '',
            name: '',
            employeeNo: '',
            department: '',
            group: '',
            email: '',
            phoneNo: '',
            faceImg: imgPath,
            otRequestData: [],
            reason: '',
            headDepartmentApproval: '',
            headDepartmentApprovalStatus: '',
            adminApproval: '',
            adminApprovalStatus: '',
            canSave: true,
            otRequestOverlap: {}
        }
    },

    methods: {

        async getOvertimeRequest (id) {
            this.$store.dispatch('setLoading', true)
            const url = `overtime-request/${id}`
            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                const data = res.data.data
                this.id = id
                this.status = data.status
                this.requestStatus = data.title
                this.name = data.fullname
                this.employeeNo = data.employeeNo
                this.department = data.department
                this.group = data.group
                this.email = data.email
                this.phoneNo = data.phoneNo
                this.otRequestData = data.otRequestData
                this.reason = data.reason
                this.headDepartmentApproval = data.headDepartmentApproval
                this.headDepartmentApprovalStatus = data.headDepartmentApprovalStatus
                this.adminApproval = data.adminApproval
                this.adminApprovalStatus = data.adminApprovalStatus
                this.$refs.overtimeRequest.status = data.status

                if (data.status !== '') {
                    this.canSave = false
                }

                if (data.hdReviewedStatus !== 'APV') {
                    this.canSave = false
                }

                if (data.f_path) {
                    this.faceImg = data.f_path
                }

                this.$store.dispatch('setLoading', false)
            } else {
                this.cancel()
            }
        },

        async updateOvertimeRequest () {
            this.$store.dispatch('setLoading', true)
            const url = `overtime-request/review/${this.id}`
            const form = {
                status: this.status
            }

            const res = await this.axios.put(url, form)
            this.checkResponse(res)
        },

        checkResponse (res) {
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.overtimeRequestForm.congratulation'),
                    text: res.data.msg,
                    type: 'success'
                })
                this.cancel()
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
                for (const property in this.errors) {
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.overtimeRequestForm.errorMessage'),
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            } else if (res && res.data && res.data.status === 'error_overlap') {
                this.otRequestOverlap = res.data.errors
                this.$refs.otOverlapDisplayModal.dialog = true
                this.$store.dispatch('setLoading', false)
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.overtimeRequestForm.errorMessage'),
                    text: res.data.msg,
                    type: 'error'
                })
            }
        },

        async submit () {
            if (!this.status) {
                return
            }
            await this.updateOvertimeRequest()
        },

        cancel () {
            this.$router.push({ name: 'overtimeRequest' }, () => {})
        }

    },

    async mounted () {
        await this.getOvertimeRequest(this.$route.params.id)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getOvertimeRequest(this.$route.params.id)
            },
            deep: true
        }
    }

}
</script>

<style lang="scss" scoped>

.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
}

.headerOfTable {
    font-size: 14px;
    border-bottom: 2px inset;
}

.rowOfOTRequest {
    border-bottom: 2px inset;
}

.otr-label {
    font-size: 14px;
    line-height: 1.25;
    color: #6c6c6c;
}

.otr-text {
    font-size: 16px;
    line-height: 1.19;
    color: #131410;
    margin-top: 5px;
    margin-bottom: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.otr-textarea {
    font-size: 16px;
    line-height: 1.19;
    color: #131410;
    margin-top: 5px;
    margin-bottom: 14px;
}

.otr-text-status {
    font-size: 16px;
    line-height: 1.19;
    color: #131410;
    margin-top: 5px;
    margin-bottom: 5px;
}
.otr-text-approval {
    font-size: 16px;
    line-height: 1.19;
    color: #131410;
    margin-bottom: 14px;
}

.otr-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.otr-employee-no {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.otr-icon {
    text-align: center;
    width: 36px;
    height: 36px;
    margin: 0px 10px 3px 0;
    border-radius: 5px;
    background-color: #faede7;
}

.icon {
    padding-top: 10px;
    font-size: 18px;
    width: 18px;
    height: 18px;
    line-height: 1.22;
    letter-spacing: normal;
    color: #d76436;
}

.requestStatusText {
    text-align: left;
    color: #6c98ba;
}

.custom-scrollbar {
    overflow-y: scroll;
    height: 100vh;
    max-height:500px
}
.custom-scrollbar::-webkit-scrollbar {
    width: 12px;
    background-color: #F5F5F5;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #555;
}

.custom-scrollbar::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #F5F5F5;
}

.content-container .v-data-table__wrapper tbody td {
    white-space: unset !important;
}

thead th {
    font-size: 14px;
}

.request-status-detail {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}

.otr-reason {
    display: inline-block;
}

.otr-approval {
    width: 50%;
    display: inline-block;
}
</style>
